/**
 * Created by Rodrigo Quesada on 03/03/17.
 */
import {Component, Injectable} from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
    styles: [require('../shared/section/section.component.scss'), require('./release-page.component.scss')]
})
@Injectable()
export class ReleasePageComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/release/release-page.component.ts